export const AdminViewSkeleton = () => {
  return <div className="h-10 w-full animate-pulse rounded-md bg-slate-200" />;
};
